import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

function comparator (a, b) {
  if (a.nombre > b.nombre) return 1
  if (a.nombre < b.nombre) return -1
  return 0
}

export const fetchCereales = async () => lrsAdapter(await getAxiosInstance().get(`/cereal_habilitado?=r{}`)).data.sort(comparator)

class Cereal {
  static async getDatosCereal (claveCereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cereal?r=` +
    `{"clave":{"nombre_corto":"${claveCereal}"}}`)

    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    console.log('Cereal', response)
    return response.data[0]
  }

  static async getNombreCorto (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cereal_nombre?r=` +
    `{"clave":{"nombre":"${nombre}"}}`)

    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }

  static async getCereales () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cereal_habilitado?=r{}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data.sort(comparator)
  }

  static getEstadoPedidosCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`corte_de_pedido_de_calado_pendiente`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static submitCortePedidoCalado (fechaDeCorte, cereal) {
    const axios = getAxiosInstance()
    const promise = axios.post(`corte_de_pedido_de_calado_pendiente`, `{"valores": {"fecha_de_corte": "${fechaDeCorte}", "cereal": "${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static deleteCortePedidoCalado (fechaDeCorte, cereal) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`corte_de_pedido_de_calado_pendiente?r=` +
      `{"clave": {"fecha_de_corte": "${fechaDeCorte}", "cereal": "${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }
}

export default Cereal
